import { formData, globals as gl } from './globals'
// Modal ########################################################################################################
let $modal;

export class Modal {
  
  constructor(newText="sampleText") {
    //this.modal += 1;
    console.log('initialising modal:', `modal`);
    this.text = newText;

    $modal = $('<div />', {
      'id': ``,
      'class': 'modal fade',
      'tabindex': '-1',
      'role': 'dialog'
    });

    let $modalDialog = $('<div />', {
      'id': 'modal-dialog-a',
      'class': 'modal-dialog',
      'role': 'document'
    }).appendTo($modal);

    let $modalContent = $('<div />', {
      'id': 'modal-content-a',
      'class': 'modal-content',
      'html': `<div class="modal-body">
                ${this.text}
              </div>`
    }).appendTo($modalDialog);

    let $modalFooter = $('<div />', {
      'class': 'modal-body text-center',
      'id': 'btn-holder-a'
    }).appendTo($modalContent);

    $('<input />', { //agree btn
      type: 'button',
      value: 'Ok',
      'data-dismiss': 'modal',
      'class': 'btn btn-primary',
      'id': `ok-a`
    }).click((function (e) {
      return function (e) {
        e.preventDefault();
        $('#newsletter-form .checkbox-custom-label').removeClass('error');        // zrusime error oznaceni vsech checkboxu, ze nebyl zadny vyplnen
      };
    })()).appendTo($modalFooter);
    //$modalWrapper.appendTo($('body'));
    $modal.appendTo('body');
  }


  setText(text) {
    this.text = text;
  };
  show() {
    $modal.modal('show');
  };


}
// Modal ########################################################################################################



// WEBPACK FOOTER //
// ./app/modalCls.js